import React, { useEffect } from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import { BookOpen, ExternalLink } from "lucide-react";

const DocsPage = () => {
  useEffect(() => {
    window.location.href = "https://docs.verasist.ai";
  }, []);

  return (
    <PageLayout>
      <SectionReveal>
        <section className="py-32 px-6 text-center" style={{ minHeight: "60vh" }}>
          <div className="max-w-lg mx-auto">
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
              <BookOpen size={32} />
            </div>
            <h1 className="text-[24px] font-bold mb-3" style={{ color: "var(--fg)" }}>Dokümantasyona yönlendiriliyorsunuz...</h1>
            <p className="text-[14px] mb-8" style={{ color: "var(--fg)", opacity: 0.75 }}>
              Geliştirici dokümantasyonumuza erişmek için docs.verasist.ai adresine yönlendiriliyorsunuz.
            </p>
            <a
              href="https://docs.verasist.ai"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
              style={{ background: "var(--brand-navy)", color: "#fff" }}
            >
              <ExternalLink size={16} /> docs.verasist.ai
            </a>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default DocsPage;
